import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import studentService from '../services/studentService';
import admissionService from '../services/admissionService';
import './StudentAnalytics.css';
import PoliceVerificationForm from './PoliceverificationForm';

/* ─── Edit Admission Modal ──────────────────────────────────────────────────── */
const EditAdmissionModal = ({ admission, onClose, onSaved }) => {
  const [form, setForm] = useState({
    dateOfAdmission: admission.dateOfAdmission || '',
    validTill:       admission.validTill || '',
    hostelFees:      admission.totalFees  || '',
    paymentMode:     admission.paymentMode || '',
    transactionId:   admission.transactionId || '',
    remarks:         admission.remarks || '',
    accommodation:   admission.amenities?.accommodation || false,
    breakfast:       admission.amenities?.breakfast     || false,
    dinner:          admission.amenities?.dinner        || false,
    wifi:            admission.amenities?.wifi          || false,
    readingRoom:     admission.amenities?.readingRoom   || false,
    transport:       admission.amenities?.transport     || false,
    lunch:           admission.amenities?.lunch         || false,
    gymnasium:       admission.amenities?.gymnasium     || false,
    inst1: admission.installments?.[0] || '',
    inst2: admission.installments?.[1] || '',
    inst3: admission.installments?.[2] || '',
    inst4: admission.installments?.[3] || '',
  });
  const [saving, setSaving] = useState(false);
  const [apiError, setApiError] = useState('');

  const setF = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const inp = (hasErr) => ({
    width: '100%', padding: '11px 0', border: 'none',
    borderBottom: `1px solid ${hasErr ? '#E85D4A' : '#E8E4DF'}`,
    background: 'transparent', fontSize: 14, outline: 'none',
    fontFamily: 'Work Sans, sans-serif', color: '#2C2C2C',
  });
  const lbl = { display: 'block', fontSize: 11, fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase', color: '#6B6B6B', marginBottom: 4 };

  const handleSave = async () => {
    setSaving(true);
    setApiError('');
    try {
      const updated = await admissionService.updateFull(admission.id, {
        totalFees:       parseFloat(form.hostelFees) || 0,
        dateOfAdmission: form.dateOfAdmission || null,
        validTill:       form.validTill || null,
        paymentMode:     form.paymentMode || null,
        transactionId:   form.transactionId || null,
        remarks:         form.remarks || null,
        accommodation:   form.accommodation,
        breakfast:       form.breakfast,
        dinner:          form.dinner,
        wifi:            form.wifi,
        readingRoom:     form.readingRoom,
        transport:       form.transport,
        lunch:           form.lunch,
        gymnasium:       form.gymnasium,
        inst1: form.inst1 || null,
        inst2: form.inst2 || null,
        inst3: form.inst3 || null,
        inst4: form.inst4 || null,
      });
      onSaved(updated);
    } catch (e) {
      setApiError(e.response?.data?.message || 'Failed to save. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(27,59,95,0.65)', zIndex:1200, display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}>
      <div style={{ background:'#fff', width:720, maxHeight:'92vh', overflowY:'auto', borderRadius:4, boxShadow:'0 24px 64px rgba(0,0,0,0.35)' }}>
        {/* Header */}
        <div style={{ background:'#1B3B5F', padding:'22px 40px', position:'sticky', top:0, zIndex:10, display:'flex', alignItems:'center', justifyContent:'space-between' }}>
          <div>
            <h3 style={{ color:'#fff', margin:0, fontFamily:'Cormorant Garamond,serif', fontSize:26, fontWeight:400 }}>Edit Admission</h3>
            <p style={{ color:'rgba(255,255,255,0.7)', margin:'4px 0 0', fontSize:13 }}>Update fees, amenities and installment schedule</p>
          </div>
          <button onClick={onClose} style={{ background:'rgba(255,255,255,0.15)', border:'none', color:'#fff', cursor:'pointer', padding:'8px 16px', borderRadius:4, fontSize:13 }}>✕ Close</button>
        </div>

        <div style={{ padding:40 }}>
          {/* Fees + Payment */}
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'0 40px', marginBottom:24 }}>
            <div>
              <h4 style={{ fontFamily:'Cormorant Garamond,serif', fontSize:18, color:'#1B3B5F', marginBottom:16 }}>Fee Details</h4>
              <div style={{ marginBottom:18 }}><label style={lbl}>Date of Admission</label><input type="date" style={inp()} value={form.dateOfAdmission} onChange={e=>setF('dateOfAdmission',e.target.value)} /></div>
              <div style={{ marginBottom:18 }}><label style={lbl}>Valid Till</label><input type="date" style={inp()} value={form.validTill} onChange={e=>setF('validTill',e.target.value)} /></div>
              <div style={{ marginBottom:18 }}><label style={lbl}>Total Fees (₹)</label><input type="number" style={inp()} value={form.hostelFees} onChange={e=>setF('hostelFees',e.target.value)} /></div>
              <div style={{ marginBottom:18 }}>
                <label style={lbl}>Payment Mode</label>
                <select style={{...inp(), cursor:'pointer'}} value={form.paymentMode} onChange={e=>setF('paymentMode',e.target.value)}>
                  <option value="">Select</option>
                  {['CASH','ONLINE','CARD','CHEQUE','DD'].map(v=><option key={v} value={v}>{v}</option>)}
                </select>
              </div>
              <div style={{ marginBottom:18 }}><label style={lbl}>Transaction ID</label><input style={inp()} placeholder="Optional" value={form.transactionId} onChange={e=>setF('transactionId',e.target.value)} /></div>
            </div>

            {/* Amenities */}
            <div>
              <h4 style={{ fontFamily:'Cormorant Garamond,serif', fontSize:18, color:'#1B3B5F', marginBottom:16 }}>Amenities Included</h4>
              {[['accommodation','Accommodation'],['breakfast','Breakfast'],['dinner','Dinner'],['wifi','Wi-Fi'],['readingRoom','Reading Room'],['transport','Transport'],['lunch','Lunch'],['gymnasium','Gymnasium']].map(([k,label])=>(
                <label key={k} style={{ display:'flex', alignItems:'center', gap:14, marginBottom:14, cursor:'pointer' }}>
                  <input type="checkbox" checked={form[k]} onChange={e=>setF(k,e.target.checked)}
                    style={{ width:16, height:16, accentColor:'#1B3B5F', cursor:'pointer' }} />
                  <span style={{ fontSize:14, color:'#2C2C2C' }}>{label}</span>
                </label>
              ))}
            </div>
          </div>

          {/* Installments */}
          <div style={{ marginBottom:24 }}>
            <h4 style={{ fontFamily:'Cormorant Garamond,serif', fontSize:18, color:'#1B3B5F', marginBottom:16 }}>Installment Dates</h4>
            <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:'0 20px' }}>
              {[1,2,3,4].map(n=>(
                <div key={n} style={{ marginBottom:18 }}>
                  <label style={lbl}>Instalment {n}</label>
                  <input type="date" style={inp()} value={form[`inst${n}`]} onChange={e=>setF(`inst${n}`,e.target.value)} />
                </div>
              ))}
            </div>
          </div>

          {/* Remarks */}
          <div style={{ marginBottom:24 }}>
            <label style={lbl}>Remarks</label>
            <textarea style={{...inp(), resize:'none', height:64}} placeholder="Optional notes…" value={form.remarks} onChange={e=>setF('remarks',e.target.value)} />
          </div>

          {apiError && <div style={{ background:'#fff5f5', border:'1px solid #e5534b', borderRadius:4, padding:'12px 16px', color:'#9e2a2a', fontSize:13, marginBottom:16 }}>{apiError}</div>}

          <div style={{ display:'flex', gap:16, justifyContent:'flex-end' }}>
            <button onClick={onClose} style={{ padding:'12px 28px', background:'transparent', border:'1px solid #C4BEB8', borderRadius:4, cursor:'pointer', fontSize:14, color:'#6B6B6B' }}>Cancel</button>
            <button onClick={handleSave} disabled={saving} style={{ padding:'12px 32px', background:'#1B3B5F', color:'#fff', border:'none', borderRadius:4, cursor: saving ? 'not-allowed' : 'pointer', fontSize:14, fontWeight:600, opacity: saving ? 0.7 : 1 }}>
              {saving ? 'Saving…' : '✓ Save Changes'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};


const StudentAnalytics = ({ onNavigate, onLogout, studentId }) => {
  const [student, setStudent] = useState(null);
  const [admission, setAdmission] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showPoliceForm, setShowPoliceForm] = useState(false);
  const [showEditAdmission, setShowEditAdmission] = useState(false);

  useEffect(() => {
    if (studentId) {
      loadStudentData();
    }
  }, [studentId]);

  const loadStudentData = async () => {
    setLoading(true);
    try {
      const data = await studentService.getStudentById(studentId);
      setStudent(data);

      // Fetch FULL admission data (includes installments + amenities)
      try {
        const adm = await admissionService.getByStudentId(studentId);
        if (adm) {
          console.log('[StudentAnalytics] Admission loaded:', {
            id: adm.id,
            totalFees: adm.totalFees,
            validTill: adm.validTill,
            installments: adm.installments,
            amenities: adm.amenities,
            roomBlock: adm.roomBlock,
            roomNumber: adm.roomNumber,
            bedNumber: adm.bedNumber,
            bedCode: adm.bedCode,
          });
          setAdmission(adm);
        } else {
          console.log('[StudentAnalytics] No admission found for studentId:', studentId);
        }
      } catch (admErr) {
        console.log('[StudentAnalytics] Error loading admission:', admErr);
      }
    } catch (error) {
      console.error('Error loading student:', error);
    } finally {
      setLoading(false);
    }
  };

  // ── Format Helpers ─────────────────────────────────────────────────────────

  const formatDate = (dateString) => {
    if (!dateString) return 'Not provided';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  // ── Days Remaining: uses admission.validTill ────────────────────────────────
  const calculateDaysRemaining = () => {
    const till = admission?.validTill || admission?.validityDate;
    if (!till) return 'N/A';
    const diffMs = new Date(till) - new Date();
    const days = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
    return days > 0 ? days : 0;
  };

  const getValidTillLabel = () => {
    const till = admission?.validTill || admission?.validityDate;
    return till ? `Valid till ${formatDate(till)}` : 'Validity not set';
  };

  // ── Total Fees: real admission.totalFees ────────────────────────────────────
  const getTotalFees = () => {
    if (!admission) return null;
    return Number(admission.totalFees) || null;
  };

  // ── Amount Paid: from paidFees field saved at confirm admission ─────────────
  const getAmountPaid = () => {
    if (!admission) return 0;
    if (admission.paidFees != null) return Number(admission.paidFees);
    if (admission.amountPaid != null) return Number(admission.amountPaid);
    return 0;
  };

  const getBalanceDue = () => {
    const total = getTotalFees();
    if (total === null) return null;
    return total - getAmountPaid();
  };

  // ── Installments: from admission.installments (date strings or objects) ──────
  // Backend receives: installments: ["2024-01-10", "2024-03-15", "2024-06-10", "2024-09-10"]
  // May return same array or objects like {date, amount, status}
  const getInstallments = () => {
    if (!admission?.installments) return [];
    // Handle installments being a JSON string from backend
    let raw = admission.installments;
    if (typeof raw === 'string') {
      try { raw = JSON.parse(raw); } catch { return []; }
    }
    if (!Array.isArray(raw) || raw.length === 0) return [];

    const total = getTotalFees() || 0;
    const count = raw.length;

    // Distribute total evenly; last installment gets the remainder
    const perSlot   = count > 0 ? Math.floor(total / count) : 0;
    const remainder = total - perSlot * (count - 1);

    return raw.map((item, idx) => {
      // Handle both formats: plain date string or {date, amount, status} object
      const isObj   = item && typeof item === 'object';
      const dateStr = isObj ? (item.date || item.dueDate || '') : item;
      const amount  = isObj && item.amount
        ? Number(item.amount)
        : (idx === count - 1 ? remainder : perSlot);
      const dueDate = dateStr ? new Date(dateStr) : null;
      const isPast  = dueDate ? dueDate < new Date() : false;
      const status  = isObj && item.status
        ? item.status
        : (isPast ? 'paid' : 'pending');

      return {
        date:   dateStr ? formatDate(dateStr) : `Instalment ${idx + 1}`,
        amount,
        status,
      };
    });
  };

  // ── Package Inclusions: real admission.amenities booleans ───────────────────
  const AMENITY_LABELS = {
    accommodation: 'Accommodation',
    breakfast:     'Breakfast',
    dinner:        'Dinner',
    wifi:          'WiFi',
    readingRoom:   'Reading Room',
    transport:     'Transport',
    lunch:         'Lunch',
    gymnasium:     'Gymnasium',
  };

  const getPackageInclusions = () => {
    if (!admission?.amenities) return { included: [], excluded: [] };
    // Handle amenities being a plain object or a JSON string
    let amenities = admission.amenities;
    if (typeof amenities === 'string') {
      try { amenities = JSON.parse(amenities); } catch { return { included: [], excluded: [] }; }
    }
    if (typeof amenities !== 'object') return { included: [], excluded: [] };
    const included = Object.keys(AMENITY_LABELS).filter(k => amenities[k] === true).map(k => AMENITY_LABELS[k]);
    // Only show excluded for amenities that were explicitly set to false (not just missing)
    const excluded = Object.keys(AMENITY_LABELS).filter(k => amenities[k] === false).map(k => AMENITY_LABELS[k]);
    return { included, excluded };
  };

  // ── Room Details: parsed from admission bed fields ───────────────────────────
  // Bed code format: "AR-211"  → roomBlock="AR", roomNumber="21", bedNumber="1"
  //   prefix[0]    = tower  : "A" or "B"
  //   prefix[1]    = wing   : "R"(ear) or "F"(ront)
  //   roomNumber[0] = floor digit, roomNumber[1] = room digit
  const getRoomDetails = () => {
    if (!admission) return null;

    // Prefer bedCode if available; fall back to roomBlock/roomNumber/bedNumber
    const bedCode   = admission.bedCode;
    const roomBlock = admission.roomBlock;
    const roomNumber= admission.roomNumber;   // e.g. "21" = floor 2, room 1
    const bedNumber = admission.bedNumber;    // e.g. "1"

    if (!bedCode && !roomBlock) return null;

    let tower = '', wing = '', floorDigit = '', roomDigit = '', bedDigit = '';

    if (bedCode && bedCode.includes('-')) {
      // Parse directly from bedCode: "AR-211"
      const dash   = bedCode.indexOf('-');
      const prefix = bedCode.substring(0, dash);       // "AR"
      const rest   = bedCode.substring(dash + 1);      // "211"
      tower      = prefix[0];                           // "A"
      wing       = prefix[1] === 'R' ? 'Rear' : 'Front';
      floorDigit = rest.length >= 3 ? rest.substring(0, rest.length - 2) : '';   // "2"
      roomDigit  = rest.length >= 2 ? rest.substring(rest.length - 2, rest.length - 1) : rest; // "1"
      bedDigit   = rest.substring(rest.length - 1);    // "1"
    } else {
      // Build from separate stored fields: roomBlock="AR", roomNumber="21", bedNumber="1"
      tower      = roomBlock ? roomBlock[0] : '';
      wing       = roomBlock && roomBlock[1] === 'R' ? 'Rear' : 'Front';
      // roomNumber "21" → floor="2", room="1"
      const rn   = (roomNumber || '').toString().trim();
      floorDigit = rn.length >= 2 ? rn.charAt(0) : '';          // first char = floor
      roomDigit  = rn.length >= 2 ? rn.charAt(rn.length - 1) : rn; // last char = room
      bedDigit   = (bedNumber || '').toString().trim();
    }

    const floorSuffix = (n) => {
      const num = parseInt(n, 10);
      if (isNaN(num) || num < 1) return '—';
      if (num === 1) return '1st Floor';
      if (num === 2) return '2nd Floor';
      if (num === 3) return '3rd Floor';
      return `${num}th Floor`;
    };

    // Reconstruct bedCode if not directly available
    const displayBedCode = bedCode ||
      (roomBlock && roomNumber && bedNumber ? `${roomBlock}-${roomNumber}${bedNumber}` : '—');

    return {
      bedCode:  displayBedCode,
      tower:    tower ? `Tower ${tower}` : '—',
      wing:     wing || '—',
      floor:    floorSuffix(floorDigit),
      roomNum:  roomDigit || '—',
      bedNum:   bedDigit || '—',
      roomType: '4 Sharing',
    };
  };

  const handleDownloadProfile = () => {
    // Open the details modal and trigger print
    setShowDetailsModal(true);
    setTimeout(() => {
      window.print();
    }, 500);
  };

  const handlePoliceVerification = () => {
    setShowPoliceForm(true);
  };

  if (loading) {
    return (
      <div className="app-layout">
        <Sidebar activeItem="admission" onNavigate={onNavigate} onLogout={onLogout} />
        <main className="main-content">
          <div style={{ padding: '50px', textAlign: 'center' }}>
            <div style={{ fontSize: '18px', color: '#6B6B6B' }}>Loading student data...</div>
          </div>
        </main>
      </div>
    );
  }

  if (!student) {
    return (
      <div className="app-layout">
        <Sidebar activeItem="admission" onNavigate={onNavigate} onLogout={onLogout} />
        <main className="main-content">
          <div style={{ padding: '50px', textAlign: 'center' }}>
            <div style={{ fontSize: '18px', color: '#E85D4A' }}>Student not found</div>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="app-layout">
      <Sidebar activeItem="admission" onNavigate={onNavigate} onLogout={onLogout} />
      
      <main className="main-content">
        {/* Top Bar */}
        <div className="top-bar">
          <div className="breadcrumb">
            <a href="#" onClick={(e) => { e.preventDefault(); onNavigate('admission'); }}>Admission</a> / <span>Student Analytics</span>
          </div>
          <h1 className="page-title">Student Analytics Dashboard</h1>
        </div>

        {/* Student Header */}
        <div className="analytics-student-header">
          {student.photoUrl ? (
            <img
              src={studentService.getPhotoUrl(student.id)}
              alt="Student"
              className="analytics-header-photo"
              onError={e => { e.target.style.display='none'; e.target.nextSibling.style.display='flex'; }}
            />
          ) : null}
          <div className="analytics-header-photo" style={{display: student.photoUrl ? 'none' : 'flex', alignItems:'center', justifyContent:'center', background:'#2A4A6B', fontSize:40, color:'white'}}>👤</div>
          <div className="analytics-header-info">
            <div className="analytics-header-name">{student.fullName || 'Student Name'}</div>
            <div className="analytics-header-meta">
              <div className="analytics-header-meta-item">
                <span>🆔</span>
                <span>Student ID: {admission?.admissionNumber || student.registrationId || 'N/A'}</span>
              </div>
              <div className="analytics-header-meta-item">
                <span>📍</span>
                <span>Room: {admission?.bedCode || admission?.roomBlock
                  ? `${admission.bedCode || admission.roomBlock + '-' + admission.roomNumber}`
                  : 'Not Allocated'}</span>
              </div>
              <div className="analytics-header-meta-item">
                <span>📅</span>
                <span>Admitted: {formatDate(student.createdAt)}</span>
              </div>
              <div className="analytics-header-meta-item">
                <span>📞</span>
                <span>{student.mobile || 'N/A'}</span>
              </div>
            </div>
          </div>
        </div>

        {/* KPI Cards */}
        <div className="analytics-kpi-grid">
          <div className="analytics-kpi-card fees">
            <div className="analytics-kpi-icon">💰</div>
            <div className="analytics-kpi-label">Total Fees</div>
            <div className="analytics-kpi-value">
              {getTotalFees() !== null ? `₹${getTotalFees().toLocaleString()}` : '—'}
            </div>
            <div className="analytics-kpi-subtext">
              {admission ? 'As per admission record' : 'Admission not confirmed'}
            </div>
          </div>

          <div className="analytics-kpi-card balance">
            <div className="analytics-kpi-icon">⚠️</div>
            <div className="analytics-kpi-label">Balance Due</div>
            <div className="analytics-kpi-value">
              {getBalanceDue() !== null ? `₹${getBalanceDue().toLocaleString()}` : '—'}
            </div>
            <div className="analytics-kpi-subtext">
              {getAmountPaid() > 0 ? `₹${getAmountPaid().toLocaleString()} paid` : 'No payments recorded yet'}
            </div>
          </div>

          <div className="analytics-kpi-card verification">
            <div className="analytics-kpi-icon">🛡️</div>
            <div className="analytics-kpi-label">Police Verification</div>
            <div className="analytics-kpi-value">{admission?.policeVerification || 'Pending'}</div>
            <div className="analytics-kpi-subtext">
              {admission?.verificationDays ? `For ${admission.verificationDays} days` : 'Verification pending'}
            </div>
          </div>

          <div className="analytics-kpi-card validity">
            <div className="analytics-kpi-icon">📆</div>
            <div className="analytics-kpi-label">Days Remaining</div>
            <div className="analytics-kpi-value">{calculateDaysRemaining()}</div>
            <div className="analytics-kpi-subtext">{getValidTillLabel()}</div>
          </div>
        </div>

        {/* Content Grid */}
        <div className="content-area">
          {/* Row 1: Fee Breakdown + Payment Schedule */}
          <div className="analytics-content-grid">
            {/* Fee Breakdown */}
            <div className="analytics-card">
              <div className="analytics-card-header">
                <span>💳</span>
                <span>Fee Breakdown</span>
              </div>
              <div className="analytics-card-body">
                {!admission ? (
                  <div style={{ textAlign: 'center', padding: '30px 0', color: '#C4BEB8', fontSize: 14 }}>
                    Admission not confirmed yet
                  </div>
                ) : (
                  <div className="analytics-fee-breakdown">
                    {/* Room Info */}
                    {admission.roomType && (
                      <div className="analytics-fee-item">
                        <span className="analytics-fee-item-label">Room Type</span>
                        <span className="analytics-fee-item-amount" style={{ fontSize: 13 }}>
                          {{'4sharing':'4 Sharing','2sharing':'2 Sharing (Twin)','2sharingPremium':'2 Sharing (Premium)','private':'Single / Private'}[admission.roomType] || admission.roomType}
                        </span>
                      </div>
                    )}
                    {admission.months > 0 && (
                      <div className="analytics-fee-item">
                        <span className="analytics-fee-item-label">Months Billed</span>
                        <span className="analytics-fee-item-amount" style={{ fontSize: 13 }}>
                          {admission.months} {admission.months === 1 ? 'month' : 'months'}
                        </span>
                      </div>
                    )}
                    {/* Fee Components — always show */}
                    <div className="analytics-fee-item">
                      <span className="analytics-fee-item-label">Accommodation Charges</span>
                      <span className="analytics-fee-item-amount">₹{Number(admission.hostelFees||0).toLocaleString('en-IN')}</span>
                    </div>
                    <div className="analytics-fee-item">
                      <span className="analytics-fee-item-label">Food Charges</span>
                      <span className="analytics-fee-item-amount">₹{Number(admission.foodCharges||0).toLocaleString('en-IN')}</span>
                    </div>
                    <div className="analytics-fee-item">
                      <span className="analytics-fee-item-label">Maintenance Fix Charges</span>
                      <span className="analytics-fee-item-amount">₹{Number(admission.maintenanceCharges||0).toLocaleString('en-IN')}</span>
                    </div>
                    <div className="analytics-fee-item">
                      <span className="analytics-fee-item-label">Security Deposit</span>
                      <span className="analytics-fee-item-amount">₹{Number(admission.refundableDeposit||0).toLocaleString('en-IN')}</span>
                    </div>
                    <div className="analytics-fee-item">
                      <span className="analytics-fee-item-label">Prepaid Card</span>
                      <span className="analytics-fee-item-amount">₹{Number(admission.prepaidCard||0).toLocaleString('en-IN')}</span>
                    </div>
                    <div className="analytics-fee-item">
                      <span className="analytics-fee-item-label">Mattress &amp; Pillow</span>
                      <span className="analytics-fee-item-amount">₹{Number(admission.mattressCharge||0).toLocaleString('en-IN')}</span>
                    </div>
                    {(admission.gst > 0) && (
                      <div className="analytics-fee-item">
                        <span className="analytics-fee-item-label">GST</span>
                        <span className="analytics-fee-item-amount">₹{Number(admission.gst).toLocaleString('en-IN')}</span>
                      </div>
                    )}
                    {/* Payment Info */}
                    <div className="analytics-fee-item">
                      <span className="analytics-fee-item-label">Payment Mode</span>
                      <span className="analytics-fee-item-amount" style={{ fontSize: 13 }}>{admission.paymentMode || '—'}</span>
                    </div>
                    {admission.transactionId && (
                      <div className="analytics-fee-item">
                        <span className="analytics-fee-item-label">Transaction ID</span>
                        <span className="analytics-fee-item-amount" style={{ fontSize: 12, fontFamily: 'monospace' }}>{admission.transactionId}</span>
                      </div>
                    )}
                    <div className="analytics-fee-item">
                      <span className="analytics-fee-item-label">Date of Admission</span>
                      <span className="analytics-fee-item-amount" style={{ fontSize: 13 }}>{formatDate(admission.dateOfAdmission)}</span>
                    </div>
                    <div className="analytics-fee-item">
                      <span className="analytics-fee-item-label">Valid Till</span>
                      <span className="analytics-fee-item-amount" style={{ fontSize: 13 }}>{formatDate(admission.validTill || admission.validityDate)}</span>
                    </div>
                    {/* Totals */}
                    <div className="analytics-fee-item" style={{ borderTop: '2px solid #E8E4DF', marginTop: 4, paddingTop: 10 }}>
                      <span className="analytics-fee-item-label" style={{ fontWeight: 700, color: '#1B3B5F' }}>Total Payable</span>
                      <span className="analytics-fee-item-amount" style={{ fontWeight: 700, color: '#1B3B5F' }}>
                        {getTotalFees() !== null ? `₹${getTotalFees().toLocaleString('en-IN')}` : '—'}
                      </span>
                    </div>
                    <div className="analytics-fee-item paid">
                      <span className="analytics-fee-item-label">Amount Paid</span>
                      <span className="analytics-fee-item-amount">₹{getAmountPaid().toLocaleString('en-IN')}</span>
                    </div>
                    <div className="analytics-fee-item pending">
                      <span className="analytics-fee-item-label">Balance Outstanding</span>
                      <span className="analytics-fee-item-amount">
                        {getBalanceDue() !== null ? `₹${getBalanceDue().toLocaleString('en-IN')}` : '—'}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
            
            {/* Payment Schedule */}
            <div className="analytics-card">
              <div className="analytics-card-header">
                <span>📅</span>
                <span>Payment Schedule</span>
              </div>
              <div className="analytics-card-body">
                {!admission ? (
                  <div style={{ textAlign: 'center', padding: '30px 0', color: '#C4BEB8', fontSize: 14 }}>
                    Admission not confirmed yet
                  </div>
                ) : getInstallments().length === 0 ? (
                  <div style={{ textAlign: 'center', padding: '30px 0', color: '#C4BEB8', fontSize: 14 }}>
                    No installment schedule set
                  </div>
                ) : (
                  <div className="analytics-timeline">
                    {getInstallments().map((installment, index) => (
                      <div key={index} className="analytics-timeline-item">
                        <div className={`analytics-timeline-dot ${installment.status === 'paid' ? 'completed' : ''}`}></div>
                        <div className="analytics-timeline-date">{installment.date}</div>
                        <div className="analytics-timeline-amount">₹{installment.amount.toLocaleString()}</div>
                        <span className={`analytics-timeline-status ${installment.status}`}>
                          {installment.status === 'paid' ? 'Paid' : 'Pending'}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Row 2: Package Inclusions + Attendance */}
          <div className="analytics-content-grid" style={{ marginTop: '30px' }}>
            {/* Package Details */}
            <div className="analytics-card">
              <div className="analytics-card-header">
                <span>📦</span>
                <span>Package Inclusions</span>
              </div>
              <div className="analytics-card-body">
                {!admission ? (
                  <div style={{ textAlign: 'center', padding: '30px 0', color: '#C4BEB8', fontSize: 14 }}>
                    Admission not confirmed yet
                  </div>
                ) : !admission.amenities ? (
                  <div style={{ textAlign: 'center', padding: '30px 0', color: '#C4BEB8', fontSize: 14 }}>
                    No amenities recorded
                  </div>
                ) : (
                  <div className="analytics-package-grid">
                    {Object.entries(AMENITY_LABELS).map(([key, label]) => {
                      const isIncluded = admission.amenities[key] === true;
                      return (
                        <div key={key} className={`analytics-package-item ${isIncluded ? 'included' : 'excluded'}`}>
                          <span className={`amenity-icon ${isIncluded ? 'amenity-yes' : 'amenity-no'}`}>
                            {isIncluded ? '✓' : '✗'}
                          </span>
                          <span>{label}</span>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
            
            {/* Attendance Chart */}
            <div className="analytics-card">
              <div className="analytics-card-header">
                <span>📊</span>
                <span>Attendance Overview</span>
                <span style={{ marginLeft: 'auto', fontSize: '18px', fontWeight: '700', color: 'rgba(255,255,255,0.9)' }}>89%</span>
              </div>
              <div className="analytics-card-body">
                <div className="analytics-chart-placeholder">
                  <div className="analytics-chart-icon">📈</div>
                  <div className="analytics-chart-text">Attendance trend chart will be displayed here</div>
                </div>
              </div>
            </div>
          </div>

          {/* Row 3: Room Details + Emergency Contacts */}
          <div className="analytics-content-grid" style={{ marginTop: '30px' }}>
            {/* Room Info */}
            <div className="analytics-card">
              <div className="analytics-card-header">
                <span>🏠</span>
                <span>Room Details</span>
              </div>
              <div className="analytics-card-body">
                {!getRoomDetails() ? (
                  <div style={{ textAlign: 'center', padding: '30px 0', color: '#C4BEB8', fontSize: 14 }}>
                    No bed allocated yet
                  </div>
                ) : (
                  <div className="analytics-room-info">
                    <div className="analytics-room-detail">
                      <div className="analytics-room-detail-label">Bed Code</div>
                      <div className="analytics-room-detail-value" style={{ fontFamily: 'monospace', fontWeight: 700, color: '#1B3B5F' }}>
                        {getRoomDetails().bedCode}
                      </div>
                    </div>
                    <div className="analytics-room-detail">
                      <div className="analytics-room-detail-label">Tower</div>
                      <div className="analytics-room-detail-value">{getRoomDetails().tower}</div>
                    </div>
                    <div className="analytics-room-detail">
                      <div className="analytics-room-detail-label">Wing</div>
                      <div className="analytics-room-detail-value">{getRoomDetails().wing}</div>
                    </div>
                    <div className="analytics-room-detail">
                      <div className="analytics-room-detail-label">Floor</div>
                      <div className="analytics-room-detail-value">{getRoomDetails().floor}</div>
                    </div>
                    <div className="analytics-room-detail">
                      <div className="analytics-room-detail-label">Room Number</div>
                      <div className="analytics-room-detail-value">{getRoomDetails().roomNum}</div>
                    </div>
                    <div className="analytics-room-detail">
                      <div className="analytics-room-detail-label">Bed Number</div>
                      <div className="analytics-room-detail-value">Bed {getRoomDetails().bedNum}</div>
                    </div>
                    <div className="analytics-room-detail">
                      <div className="analytics-room-detail-label">Room Type</div>
                      <div className="analytics-room-detail-value">{getRoomDetails().roomType}</div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            
            {/* Local Contacts */}
            <div className="analytics-card">
              <div className="analytics-card-header">
                <span>👥</span>
                <span>Emergency Contacts</span>
              </div>
              <div className="analytics-card-body">
                <div className="analytics-contacts-grid">
                  <div className="analytics-contact-card">
                    <div className="analytics-contact-label">Father</div>
                    <div className="analytics-contact-value">{student.fatherName || 'Not provided'}</div>
                    <div className="analytics-contact-label">Phone</div>
                    <div className="analytics-contact-value">{student.fatherMobile || 'Not provided'}</div>
                    <div className="analytics-contact-label">Email</div>
                    <div className="analytics-contact-value">{student.fatherEmail || 'Not provided'}</div>
                  </div>
                  <div className="analytics-contact-card secondary">
                    <div className="analytics-contact-label">Mother</div>
                    <div className="analytics-contact-value">{student.motherName || 'Not provided'}</div>
                    <div className="analytics-contact-label">Phone</div>
                    <div className="analytics-contact-value">{student.motherMobile || 'Not provided'}</div>
                    <div className="analytics-contact-label">Email</div>
                    <div className="analytics-contact-value">{student.motherEmail || 'Not provided'}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Action Bar */}
        <div className="analytics-action-bar">
          <button className="analytics-btn analytics-btn-navy" onClick={() => setShowDetailsModal(true)}>
            <span>📄</span>
            <span>View All Details</span>
          </button>
          {admission && (
            <button className="analytics-btn analytics-btn-teal" onClick={() => setShowEditAdmission(true)}>
              <span>✏️</span>
              <span>Edit Admission</span>
            </button>
          )}
          <button className="analytics-btn analytics-btn-orange" onClick={() => setShowPoliceForm(true)}>
            <span className="icon-blue">🛡️</span>
            <span>Police Verification Form</span>
          </button>
          <button className="analytics-btn analytics-btn-gold" onClick={handleDownloadProfile}>
            <span className="icon-blue">⬇️</span>
            <span>Download Student Profile</span>
          </button>
        </div>

        {/* Edit Admission Modal */}
        {showEditAdmission && admission && (
          <EditAdmissionModal
            admission={admission}
            onClose={() => setShowEditAdmission(false)}
            onSaved={(updated) => {
              setAdmission(updated);
              setShowEditAdmission(false);
            }}
          />
        )}

        {/* Police Verification Form Modal */}
        {showPoliceForm && (
          <PoliceVerificationForm 
            student={student} 
            onClose={() => setShowPoliceForm(false)} 
          />
        )}

        {/* Details Modal */}
        {showDetailsModal && (
          <div className="modal-overlay active" onClick={() => setShowDetailsModal(false)}>
            <div className="modal-container" onClick={(e) => e.stopPropagation()}>
              <div className="modal-close-bar">
                <div>
                  <div className="modal-title">Complete Student Information</div>
                  <div className="student-id-badge-detail">Student ID: {admission?.admissionNumber || student.registrationId}</div>
                </div>
                <button className="modal-close-btn" onClick={() => setShowDetailsModal(false)}>✕ Close</button>
              </div>
              <div className="modal-content-wrapper">
                {/* Student Header Card — white card matching section-card style */}
                <div style={{ background:'#fff', borderRadius:12, padding:'28px 32px', marginBottom:20, boxShadow:'0 2px 12px rgba(0,0,0,0.06)', border:'1px solid #F0EDE8' }}>
                  <div style={{ display:'flex', alignItems:'center', gap:28, marginBottom:24 }}>
                    {/* Photo */}
                    <div style={{ width:100, height:100, borderRadius:'50%', border:'3px solid #C9A227', overflow:'hidden', flexShrink:0, display:'flex', alignItems:'center', justifyContent:'center', background:'#F4F1EC', fontSize:44 }}>
                      {student.photoUrl ? (
                        <img
                          src={studentService.getPhotoUrl(student.id)}
                          alt="Student"
                          style={{ width:'100%', height:'100%', objectFit:'cover' }}
                          onError={e => { e.target.style.display='none'; e.target.nextSibling.style.display='inline'; }}
                        />
                      ) : null}
                      <span style={{ fontSize:44, display: student.photoUrl ? 'none' : 'inline' }}>👤</span>
                    </div>
                    {/* Name + ID */}
                    <div>
                      <div style={{ fontFamily:'Cormorant Garamond,serif', fontSize:32, color:'#1B3B5F', fontWeight:500, marginBottom:4 }}>{student.fullName}</div>
                      <div style={{ display:'flex', gap:10, flexWrap:'wrap' }}>
                        <span style={{ fontSize:12, fontWeight:700, padding:'3px 12px', borderRadius:20, background:'#1B3B5F20', color:'#1B3B5F' }}>
                          Student ID: {admission?.admissionNumber || student.registrationId || '—'}
                        </span>
                        {admission?.bedCode && (
                          <span style={{ fontSize:12, fontWeight:700, padding:'3px 12px', borderRadius:20, background:'#C9A22720', color:'#8B6914' }}>
                            🛏 {admission.bedCode}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* Info Grid */}
                  <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'16px 24px', borderTop:'1px solid #F0EDE8', paddingTop:20 }}>
                    {[
                      { label:'Date of Birth',   value: formatDate(student.dob) },
                      { label:'Gender',           value: student.gender },
                      { label:'Room Number',      value: admission?.bedCode || admission?.roomNumber || 'Not Allocated' },
                      { label:'Mobile Number',    value: student.mobile },
                      { label:'Email Address',    value: student.email },
                      { label:'Admission Date',   value: formatDate(admission?.dateOfAdmission || student.createdAt) },
                    ].map(f => (
                      <div key={f.label}>
                        <div style={{ fontSize:11, fontWeight:700, letterSpacing:1, textTransform:'uppercase', color:'#6B6B6B', marginBottom:5 }}>{f.label}</div>
                        <div style={{ fontSize:14, fontWeight:600, color:'#1B3B5F' }}>{f.value || '—'}</div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Personal Information */}
                <div className="section-card">
                  <div className="section-header-detail">
                    <div className="section-icon-detail">👤</div>
                    <div className="section-title-detail">
                      <h3>Personal Information</h3>
                      <p>Basic personal details and identification</p>
                    </div>
                  </div>
                  <div className="fields-grid-detail">
                    <div className="field-group-detail">
                      <div className="field-label-detail">Full Name</div>
                      <div className="field-value-detail">{student.fullName}</div>
                    </div>
                    <div className="field-group-detail">
                      <div className="field-label-detail">Date of Birth</div>
                      <div className="field-value-detail">{formatDate(student.dob)}</div>
                    </div>
                    <div className="field-group-detail">
                      <div className="field-label-detail">Gender</div>
                      <div className="field-value-detail">{student.gender}</div>
                    </div>
                    <div className="field-group-detail">
                      <div className="field-label-detail">Marital Status</div>
                      <div className="field-value-detail">{student.maritalStatus || 'Not provided'}</div>
                    </div>
                    <div className="field-group-detail">
                      <div className="field-label-detail">Religion</div>
                      <div className="field-value-detail">{student.religion || 'Not provided'}</div>
                    </div>
                    <div className="field-group-detail">
                      <div className="field-label-detail">Blood Group</div>
                      <div className="field-value-detail">{student.bloodGroup || 'Not provided'}</div>
                    </div>
                    <div className="field-group-detail">
                      <div className="field-label-detail">Native Region</div>
                      <div className="field-value-detail">{student.nativeRegion || 'Not provided'}</div>
                    </div>
                    <div className="field-group-detail">
                      <div className="field-label-detail">Mobile Number</div>
                      <div className="field-value-detail">{student.mobile}</div>
                    </div>
                    <div className="field-group-detail">
                      <div className="field-label-detail">Email Address</div>
                      <div className="field-value-detail">{student.email}</div>
                    </div>
                  </div>
                </div>

                {/* Family Details */}
                <div className="section-card">
                  <div className="section-header-detail">
                    <div className="section-icon-detail">👨‍👩‍👦</div>
                    <div className="section-title-detail">
                      <h3>Family Details</h3>
                      <p>Parent and family contact information</p>
                    </div>
                  </div>
                  <div className="fields-grid-detail">
                    <div className="field-group-detail">
                      <div className="field-label-detail">Father's Name</div>
                      <div className="field-value-detail">{student.fatherName || 'Not provided'}</div>
                    </div>
                    <div className="field-group-detail">
                      <div className="field-label-detail">Father's Mobile</div>
                      <div className="field-value-detail">{student.fatherMobile || 'Not provided'}</div>
                    </div>
                    <div className="field-group-detail">
                      <div className="field-label-detail">Father's Email</div>
                      <div className="field-value-detail">{student.fatherEmail || 'Not provided'}</div>
                    </div>
                    <div className="field-group-detail">
                      <div className="field-label-detail">Mother's Name</div>
                      <div className="field-value-detail">{student.motherName || 'Not provided'}</div>
                    </div>
                    <div className="field-group-detail">
                      <div className="field-label-detail">Mother's Mobile</div>
                      <div className="field-value-detail">{student.motherMobile || 'Not provided'}</div>
                    </div>
                    <div className="field-group-detail">
                      <div className="field-label-detail">Mother's Email</div>
                      <div className="field-value-detail">{student.motherEmail || 'Not provided'}</div>
                    </div>
                  </div>
                </div>

                {/* Address Information */}
                <div className="section-card">
                  <div className="section-header-detail">
                    <div className="section-icon-detail">📍</div>
                    <div className="section-title-detail">
                      <h3>Address Information</h3>
                      <p>Permanent and correspondence addresses</p>
                    </div>
                  </div>
                  <div className="address-columns-detail">
                    <div className="address-column-detail">
                      <h4>Permanent Address</h4>
                      <div className="address-fields-detail">
                        <div className="field-group-detail">
                          <div className="field-label-detail">Address Line 1</div>
                          <div className="field-value-detail">{student.permanentAddress?.address1 || 'Not provided'}</div>
                        </div>
                        <div className="field-group-detail">
                          <div className="field-label-detail">Address Line 2</div>
                          <div className="field-value-detail">{student.permanentAddress?.address2 || 'Not provided'}</div>
                        </div>
                        <div className="field-group-detail">
                          <div className="field-label-detail">City</div>
                          <div className="field-value-detail">{student.permanentAddress?.city || 'Not provided'}</div>
                        </div>
                        <div className="field-group-detail">
                          <div className="field-label-detail">State</div>
                          <div className="field-value-detail">{student.permanentAddress?.state || 'Not provided'}</div>
                        </div>
                        <div className="field-group-detail">
                          <div className="field-label-detail">Zip Code</div>
                          <div className="field-value-detail">{student.permanentAddress?.zipcode || 'Not provided'}</div>
                        </div>
                        <div className="field-group-detail">
                          <div className="field-label-detail">Country</div>
                          <div className="field-value-detail">{student.permanentAddress?.country || 'Not provided'}</div>
                        </div>
                      </div>
                    </div>
                    <div className="address-column-detail">
                      <h4>Correspondence Address</h4>
                      <div className="address-fields-detail">
                        <div className="field-group-detail">
                          <div className="field-label-detail">Address Line 1</div>
                          <div className="field-value-detail">{student.correspondenceAddress?.address1 || 'Same as permanent'}</div>
                        </div>
                        <div className="field-group-detail">
                          <div className="field-label-detail">Address Line 2</div>
                          <div className="field-value-detail">{student.correspondenceAddress?.address2 || 'Not provided'}</div>
                        </div>
                        <div className="field-group-detail">
                          <div className="field-label-detail">City</div>
                          <div className="field-value-detail">{student.correspondenceAddress?.city || 'Same as permanent'}</div>
                        </div>
                        <div className="field-group-detail">
                          <div className="field-label-detail">State</div>
                          <div className="field-value-detail">{student.correspondenceAddress?.state || 'Same as permanent'}</div>
                        </div>
                        <div className="field-group-detail">
                          <div className="field-label-detail">Zip Code</div>
                          <div className="field-value-detail">{student.correspondenceAddress?.zipcode || 'Same as permanent'}</div>
                        </div>
                        <div className="field-group-detail">
                          <div className="field-label-detail">Country</div>
                          <div className="field-value-detail">{student.correspondenceAddress?.country || 'Same as permanent'}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Guardian Details */}
                <div className="section-card">
                  <div className="section-header-detail">
                    <div className="section-icon-detail">👤</div>
                    <div className="section-title-detail">
                      <h3>Local Guardian Details</h3>
                      <p>Emergency contact person in the city</p>
                    </div>
                  </div>
                  <div className="fields-grid-detail">
                    <div className="field-group-detail">
                      <div className="field-label-detail">Guardian's Name</div>
                      <div className="field-value-detail">{student.localGuardianName || 'Not provided'}</div>
                    </div>
                    <div className="field-group-detail">
                      <div className="field-label-detail">Relation</div>
                      <div className="field-value-detail">{student.guardianRelation || 'Not provided'}</div>
                    </div>
                    <div className="field-group-detail">
                      <div className="field-label-detail">Guardian's Mobile</div>
                      <div className="field-value-detail">{student.guardianMobile || 'Not provided'}</div>
                    </div>
                    <div className="field-group-detail">
                      <div className="field-label-detail">Guardian's Email</div>
                      <div className="field-value-detail">{student.guardianEmail || 'Not provided'}</div>
                    </div>
                  </div>
                </div>

                {/* ID Proof Details */}
                <div className="section-card">
                  <div className="section-header-detail">
                    <div className="section-icon-detail">🆔</div>
                    <div className="section-title-detail">
                      <h3>ID Proof Details</h3>
                      <p>Government identification documents</p>
                    </div>
                  </div>
                  <div className="fields-grid-detail">
                    <div className="field-group-detail">
                      <div className="field-label-detail">Aadhar Card Number</div>
                      <div className="field-value-detail">{student.aadhar || 'Not provided'}</div>
                    </div>
                    <div className="field-group-detail">
                      <div className="field-label-detail">Emergency Contact</div>
                      <div className="field-value-detail">{student.emergencyContact || 'Not provided'}</div>
                    </div>
                    <div className="field-group-detail">
                      <div className="field-label-detail">Driving Licence Number</div>
                      <div className="field-value-detail">{student.drivingLicense || 'Not provided'}</div>
                    </div>
                    <div className="field-group-detail">
                      <div className="field-label-detail">Passport Number</div>
                      <div className="field-value-detail">{student.passport || 'Not provided'}</div>
                    </div>
                  </div>
                </div>

                {/* Academic Information */}
                {student.courses && student.courses.length > 0 && (
                  <div className="section-card">
                    <div className="section-header-detail">
                      <div className="section-icon-detail">🎓</div>
                      <div className="section-title-detail">
                        <h3>Academic Information</h3>
                        <p>University and course details</p>
                      </div>
                    </div>
                    <table className="data-table-detail">
                      <thead>
                        <tr>
                          <th>University Name</th>
                          <th>Academic Year</th>
                          <th>Stream</th>
                          <th>Timing</th>
                          <th>University Phone</th>
                        </tr>
                      </thead>
                      <tbody>
                        {student.courses.map((course, index) => (
                          <tr key={index}>
                            <td>{course.universityName || 'N/A'}</td>
                            <td>{course.academicYear || 'N/A'}</td>
                            <td>{course.stream || 'N/A'}</td>
                            <td>{course.timing || 'N/A'}</td>
                            <td>{course.phoneNo || 'N/A'}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}

                {/* Language Proficiency */}
                <div className="section-card">
                  <div className="section-header-detail">
                    <div className="section-icon-detail">🗣️</div>
                    <div className="section-title-detail">
                      <h3>Language Proficiency</h3>
                      <p>Communication skills and language abilities</p>
                    </div>
                  </div>
                  <table className="data-table-detail">
                    <thead>
                      <tr>
                        <th>To Write</th>
                        <th>To Speak</th>
                        <th>To Read</th>
                        <th>Mother Tongue</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{student.languagesToWrite || 'Not provided'}</td>
                        <td>{student.languagesToSpeak || 'Not provided'}</td>
                        <td>{student.languagesToRead || 'Not provided'}</td>
                        <td>{student.motherTongue || 'Not provided'}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}
      </main>
    </div>
  );
};

export default StudentAnalytics;